<template>
  <el-header>
    <div  :class="navBarFixed == true ? 'navBarWrap' :''" class="nav" >
      <img src="@/assets/images/logo.png" alt="logo" class="img-logo">
      <el-menu ref="elMenu"
        :default-active="activeIndex" 
        class="el-menu-demo" 
        text-color="#4b4b4b" 
        mode="horizontal">
        <el-menu-item  :index="vl.url_a"  v-for=" (vl,index) in headData" :key="index" @click="cli_redirect(vl.url_a)">
        <!-- <router-link :to="{path:vl.url_a}">{{vl.item_name}}</router-link> -->
        {{vl.item_name}}
        </el-menu-item>
      </el-menu>
      <a class="search-button" @click.prevent="searchModel"><!----><i class="el-icon-search"></i>搜索</a>
      <Search ref="childrenDom"></Search>
      <div class="jz-list">
        <dl>
          <dt>
            <img src="@/assets/images/ewm-weixin.jpg" alt="weixin">
          </dt>
          <dd>
            微信公众号
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="@/assets/images/ewm-weibo.jpg" alt="weibo">
          </dt>
          <dd>
           微博
          </dd>
        
        </dl>
        <!-- <dl>
          <dt>
            <img src="@/assets/images/ewm-douyin.jpg" alt="douyin">
          </dt>
          <dd>
            抖音
          </dd>
        </dl> -->
      </div>
    </div>
  </el-header>
</template>
<script>
import Search from "@/components/public/Search.vue"
export default{
  name:'Header',
 
  data () {
    return {
      navBarFixed:true,
      activeIndex:"1",
      scroll: 0,
      msg:'success',
      headData:[
        {item_name:'首页',url_a:'/'},
        {item_name:'深度',url_a:'/article/list'},
        {item_name:'视频',url_a:'/video/list'},
        {item_name:'杂志',url_a:'/magazine'},
        {item_name:'活动',url_a:'/activity'}
        ]
    }
  },
  mounted(){
    window.addEventListener("scroll", this.getScroll);
  },

  watch: {
    scroll: {
      handler: "showTop",
    }

  },
  created(){
    this.setHidtab()
  },

  methods: {
    setHidtab(){
      
      if(this.$route.path == '/')
      {
        this.$data.activeIndex = null
        console.log( this.$data.activeIndex)
      }
      else
      {
        this.$data.activeIndex = this.$route.path
      }

    },
    //大栏目跳转页面
    cli_redirect(url_a){
        this.$router.push(url_a);
    },
    //点击显示搜索页面
    searchModel(){
      console.log('success')
      this.$refs.childrenDom.serchStatus = true
    },
    

    handleSelect(){
      console.log('选择动作')
    },

    toggleLogo() {
        this.$router.push("/");
    },

    showTop(newValue, oldValue) {
      let header = document.getElementsByClassName("el-header")[0];
      if (newValue > 0) {
        header.classList.add("header-active");
      } else {
          header.classList.remove("header-active");
      }
      // console.log(oldValue, newValue);
    
    },

    getScroll() {
      this.scroll =document.documentElement.scrollTop || document.body.scrollTop;
    },
    
  },
  components:{
    Search
  }
}
</script>
<style>
a {
  text-decoration: none;
}
 
.router-link-active {
  text-decoration: none;
}

</style>
<style scoped>

  /deep/.is-active {
        color: #fff !important;
        background: #bd0c16 !important;
    }

.img_s{
    width:100%;
    border-radius: 6px
    ;}
div h2 {
    text-align: center;

}
  .el-header {
    width: 100%;
    text-align: center;
    background-color: #f1f1f1;
    height: 130px !important;
    line-height: 60px;
    min-width: 1200px;
  
  }
  .el-menu--horizontal > .el-menu-item{
      height:50px;
      line-height:50px;
      font-size:22px;
      color:#000000;
      font-weight:500;
      padding:0 15px;
      margin:0px 5px;
  }
  .el-menu.el-menu--horizontal{border:none}
  .el-menu {
    background: none;
    height: 50px;
    margin-top: 40px;
    display: block;
    float: left;
  }
  .img-logo{
      width:223px;
      display:block;
      float:left;
      height:80px;
      margin-top:21px;
     margin-right:40px;
    
  }
  .nav{
      width:100%
      ;max-width:1200px;
       margin:0 auto;
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover
  {
      background-color:#bd0c16;
      color: #fff !important;
      border-radius:3px

  }
 
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
  }
  .search-button {
    height: 50px;
    line-height: 50px;
    font-size: 22px;
    color: #000000;
    font-weight: 500;
    padding: 0 15px;
    margin: 40px 5px 0px;
    display: block;
    float: left;
    cursor:pointer;
  }
    .search-button i{
      margin-right:4px;
                    }
    .search-button font {
      font-size: 20px;
      color: #4b4b4b;
      font-weight: 500;
      font-family: Microsoft YaHei;
    }
    .jz-list {
      width: 300px;
      float: right;
      text-align: right;
    }
    .jz-list dl {
      width: 80px;
      display: inline-block;
      margin:14px 0px 0px 10px
    }

  .jz-list dl dt img{
      width:100%;
      display:block;
      margin:0 auto;
  }
  .jz-list dl dd{
      width:100%;
      height:20px;
      background-color:#bd0c16;
      text-align:center;
      font-size:14px;
      line-height:20px;
      display:block;
      margin:0 auto;
      color:#fff

  }
  .header-active{
      position:fixed;
      top:0px;  
      z-index:10000;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue